import React, { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";
import ArabicHeader from "../common/arabicHeader";
import ArabicFooter from "../common/arabicFooter";
import Progress from "../common/progressbar";

const RTL_STYLESHEET_ID = "bootstrap-rtl-stylesheet";

const ArabicLayout = () => {
  useEffect(() => {
    const previousLang = document.documentElement.lang;
    const previousDir = document.documentElement.dir;

    document.documentElement.lang = "ar";
    document.documentElement.dir = "rtl";

    let link = document.getElementById(RTL_STYLESHEET_ID) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.id = RTL_STYLESHEET_ID;
      link.rel = "stylesheet";
      link.href = "/bootstrap.rtl.min.css";
      document.head.appendChild(link);
    }

    return () => {
      document.documentElement.lang = previousLang || "en";
      document.documentElement.dir = previousDir || "ltr";
      const existingLink = document.getElementById(RTL_STYLESHEET_ID);
      if (existingLink) {
        existingLink.remove();
      }
    };
  }, []);

  return (
    <>
      <ArabicHeader />
      <Suspense fallback={<div style={{ minHeight: "60vh" }} />}>
        <Outlet />
      </Suspense>
      <Progress />
      <ArabicFooter />
    </>
  );
};

export default ArabicLayout;
